import { getUsefulNotice } from '@/services/menu';
import { Carousel, Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CarouselContent from './CarouselContent';
const Root = styled.div `
  margin-bottom: 20px;
  .ant-carousel {
    .slick-dots {
      bottom: -20px;
      li {
        button {
          background-color: #bfbdbd;
        }
      }
      li.slick-active {
        button {
          background-color: #50a9ff;
        }
      }
    }
    .slick-prev {
      left: -20px;
      background: none;
      color: #d8d8d8;
      font-size: 14px;
      :hover,
      :focus {
        color: #6a6a6a;
      }
    }
    .slick-next {
      right: -20px;
      background: none;
      color: #d8d8d8;
      font-size: 14px;
      :hover,
      :focus {
        color: #6a6a6a;
      }
    }
  }
`;
const MyCarousel = ({ className, style }) => {
    const [data, setData] = useState([]);
    useEffect(() => {
        getUsefulNotice().promise.then((res) => setData(res));
    }, []);
    return (<Root>
      <Carousel autoplay speed={500} autoplaySpeed={16000} pauseOnHover pauseOnDotsHover arrows nextArrow={<Icon type="right"/>} prevArrow={<Icon type="left"/>}>
        {data.map((item) => (<div key={item.name}>
            <h3 style={{ textAlign: 'center' }}>{item.name}</h3>
            <CarouselContent desc={item.content}></CarouselContent>
          </div>))}
      </Carousel>
    </Root>);
};
export default MyCarousel;
